module.exports = __webpack_public_path__ + "static/img/chixiaodou.b8c26d98.png";